let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("EIWVS")).then(() => parcelRequire('71NW9'));